import {
  Vector3,
  Mesh,
  TextureLoader,
  DoubleSide,
  RingGeometry,
  MeshDepthMaterial,
  MeshDistanceMaterial,
  RGBADepthPacking,
  RGBAFormat,
  ShadowMaterial,
  ShaderMaterial,
  MeshPhongMaterial,
  Color,
  BackSide,
  SphereGeometry
} from 'three';
import { Entity } from './entity.js';
import { showInfoPanel } from '../ui.js';
import { sceneManager } from '../script.js';
import { Group } from 'three';

import { loading } from '../loading/loading.js';

import fragmentAtm from "../../../shaders/atmAround/fragmentAtm.glsl";
import vertexAtm from "../../../shaders/atmAround/vertexAtm.glsl";

export class Planet extends Entity {
  constructor(
    size,
    texture,
    orbitRadius,
    axialTilt,
    orbitInclin,
    speedTrans,
    speedRot,
    eccentricity,
    argPeriapsis,
    longAscNode,
    label,
    centerElement,
    ring
  ) {
    super(
      centerElement,
      size,
      texture,
      orbitRadius,
      axialTilt,
      orbitInclin,
      speedTrans,
      speedRot,
      eccentricity,
      argPeriapsis,
      longAscNode,
      label
    );
    this.ring = ring;
    this.textureLoader = loading.textureLoader;
    if (this.haveMoon) {
      this.mesh.castShadow = true;
      this.mesh.receiveShadow = true;
    }
    if (this.ring) {
      this.textureLoader.load(this.ring.texture, (tex) => {
        tex.format = RGBAFormat;
        tex.needsUpdate = true;
        this.ringMesh = this.createRings(this.ring.innerRadius, this.ring.outerRadius, this.ring.shadow, tex);
        this.mesh.add(this.ringMesh);
      });
    }
    const type = "_(planet)";
    this.infoIcon.addEventListener('click', (evt) => {
      evt.stopPropagation();
      if (!centerElement.orbitRadius) {
        showInfoPanel(this.name);
      } else {
        showInfoPanel(this.name + type);
      }
    });
    if(this.objOsc.atm)
    this.createAtmosphere(this.mesh,size, this.objOsc.atm);
  }

  createAtmosphere(mesh, size, color) {
  const geometry = new SphereGeometry(size, 48, 48);
  const atmosphere = new ShaderMaterial({
    uniforms: {
      u_sunPosition: { value: new Vector3(0, 0, 0) }, 
      u_color:           { value: color },
      u_edgeSharpness:   { value: 20.0 },
      u_dayBias:         { value: 0.2 },
      u_useSun:         { value: true } 
    },

    vertexShader: vertexAtm,
    fragmentShader: fragmentAtm,
    transparent:  true,
    side:         BackSide,
    depthTest:    true,
    depthWrite:   true,
    opacity:0.8
  });

  atmosphere.needsUpdate = true;
  const atmosphereMesh = new Mesh(geometry, atmosphere);
  atmosphereMesh.frustumCulled = false;
  atmosphereMesh.scale.set(1.05, 1.05, 1.05);
  mesh.add(atmosphereMesh);
  mesh.renderOrder = 1

}

  createRings(innerRadius, outerRadius, shadowR,  texture) {
    const geo = new RingGeometry(innerRadius, outerRadius, 128);
    
    const pos = geo.attributes.position;
    const v = new Vector3();
    for (let i = 0; i < pos.count; i++) {
      v.fromBufferAttribute(pos, i);
      geo.attributes.uv.setXY(i, v.length()<1.2*innerRadius?0:1,1);
    }
    const basicMat = new MeshPhongMaterial({
      map: texture,
      alphaMap: texture,
      alphaTest: 0.08,
      opacity: 1,
      side: DoubleSide,
      transparent: true,
      depthTest: true,
      depthWrite: false,
      color: 0xEBE8E5,      
      specular: 0x000000,      
      shininess: 0,            
      emissive: 0xC9C5C0,      
      emissiveIntensity: 0.3   
    });

    const basicRing = new Mesh(geo, basicMat);
    basicRing.castShadow = shadowR;
    basicRing.receiveShadow = false;
    basicRing.rotation.x = -Math.PI/2;
    basicRing.renderOrder = 1;


    if(shadowR){
    const geoShadow = new RingGeometry(innerRadius*1.03, outerRadius*0.972, 128, 1, -Math.PI / 2, Math.PI);
   
    const shadowMat = new ShadowMaterial({
      opacity: 0.7,
      side: DoubleSide
    });
    this.shadowRing = new Mesh(geoShadow, shadowMat);
    this.shadowRing.receiveShadow = true;
    this.shadowRing.material.depthTest = true;
    this.shadowRing.material.depthWrite = false;
    this.shadowRing.renderOrder = 2;

    this.pivot = new Group();

    sceneManager.scene.add(this.pivot);
    this.pivot.add(this.shadowRing);

    this.shadowRing.rotation.x = -Math.PI/2;
   }
    const depthMat = new MeshDepthMaterial({
      depthPacking: RGBADepthPacking,
      alphaMap: texture,
      alphaTest: 0.2
    });
    const distMat = new MeshDistanceMaterial({
      alphaMap: texture,
      alphaTest: 0.2
    });
    basicRing.customDepthMaterial = depthMat;
    basicRing.customDistanceMaterial = distMat;
    return basicRing;
    
  }
}

